import { z } from 'zod';

/**
 * Runtime config served at /config.json (written from env by the container at start), so one
 * image works in every environment and no host is baked into the bundle.
 */
export const runtimeConfigSchema = z.discriminatedUnion('authMode', [
  z.object({
    authMode: z.literal('oidc'),
    apiBase: z.string(),
    /** https://<CENTRAL_ADMIN_HOST>/realms/teachpartner-host */
    oidcIssuer: z.url(),
    oidcClientId: z.string().min(1),
  }),
  z.object({
    authMode: z.literal('mock'),
    apiBase: z.string(),
    oidcIssuer: z.string().optional(),
    oidcClientId: z.string().optional(),
  }),
]);
export type RuntimeConfig = z.infer<typeof runtimeConfigSchema>;

export async function loadRuntimeConfig(fetchFn: typeof fetch = fetch): Promise<RuntimeConfig> {
  const response = await fetchFn('/config.json', { cache: 'no-store' });
  if (!response.ok) throw new Error(`Could not load /config.json (HTTP ${response.status})`);
  const parsed = runtimeConfigSchema.safeParse(await response.json());
  if (!parsed.success) throw new Error(`Invalid /config.json: ${parsed.error.message}`);
  return parsed.data;
}
